<template>
    <div class="qksm qksm8">
        <h4>八、政府性基金预算财政拨款收入支出情况说明</h4>
        <div class="nogap">
            <p>
                2020年政府性基金预算上年结转和结余{{isMoney(T8.年初结转结余)}}万元，本年收入{{isMoney(T8.本年收入)}}万元，
                本年支出{{isMoney(T8.本年支出)}}万元，年末结转和结余{{isMoney(T8.年末结转和结余)}}万元。
                <template v-if="T8.items.length>0">
                    支出具体情况如下：
                </template>
            </p>
            <p>
                <span v-for="(item,idx) in T8.items">
                    {{item.name}}（类）{{isMoney(item.value)}}万元，占{{getPercentValue(T8.items.map(e=>e.value), idx, 2)}}{{idx==T8.items.length-1?'。':'；'}}
                </span>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm8",
        props: {
            T8: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        data() {
            return {
                isPdf: this.$parent.isPdf,
            }
        },
    };
</script>
